"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _PinnedReplyLabel = _interopRequireDefault(require("@insided/deprecated-preact-components/pinned-reply/PinnedReplyLabel"));

var _globals = require("@insided/shared/utils/globals");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _common = require("@insided/shared/utils/common");

var _classnames = _interopRequireDefault(require("classnames"));

var _dateFormatDestination = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/dateFormatDestination"));

var _Content = _interopRequireDefault(require("@insided/deprecated-preact-components/common/Content"));

var PinnedReply = function PinnedReply(_ref) {
  var author = _ref.author,
      repliedAt = _ref.repliedAt,
      content = _ref.content;
  var authorId = author === null || author === void 0 ? void 0 : author.id;
  var authorName = (author === null || author === void 0 ? void 0 : author.userName) || (author === null || author === void 0 ? void 0 : author.name) || '';
  var authorUrl = (author === null || author === void 0 ? void 0 : author.url) || (authorId ? "".concat((0, _globals.getSubfolderPrefix)(), "/members/user-").concat(authorId) : undefined);
  return (0, _preact.h)("div", {
    className: "post__content pinned-reply__label--firstpost"
  }, (0, _preact.h)(_PinnedReplyLabel.default, {
    phrase: (0, _preact.h)(_phrase.default, {
      p: "reply.pinned",
      m: "Forum"
    })
  }), (0, _preact.h)("div", {
    className: "post--pinned pinned-reply-field"
  }, (0, _preact.h)("p", {
    className: "pinned-reply-field__header"
  }, (0, _preact.h)("div", {
    className: "pinned-reply-field__user-info"
  }, (0, _preact.h)(_UserAvatar.default, {
    user: author,
    extraClass: "avatar avatar--responsive avatar--pinned-reply",
    showRank: true
  }), authorUrl ? (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(authorUrl)
  }, authorName) : (0, _preact.h)("span", {
    className: "pinned-reply__username"
  }, " ", authorName, " ")), (0, _preact.h)("span", {
    className: "text--meta"
  }, (0, _preact.h)(_Tooltip.default, {
    withArrow: true,
    trigger: (0, _preact.h)("time", null, " ", _common.common.relativeDate(repliedAt), " "),
    tooltipMessage: (0, _preact.h)("div", {
      className: (0, _classnames.default)('tooltip__content', 'tooltip__content--publish-date', 'js-tooltip-content', 'position--bottom')
    }, (0, _dateFormatDestination.default)(new Date(repliedAt)))
  }))), (0, _preact.h)(_Content.default, {
    content: content,
    className: "pinned-reply__content"
  })));
};

var _default = PinnedReply;
exports.default = _default;